import { render, staticRenderFns } from "./podkateg.vue?vue&type=template&id=6c09256a&scoped=true&"
import script from "./podkateg.vue?vue&type=script&lang=js&"
export * from "./podkateg.vue?vue&type=script&lang=js&"
import style0 from "./podkateg.vue?vue&type=style&index=0&id=6c09256a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09256a",
  null
  
)

export default component.exports